import { Grid, Typography, styled } from "@mui/material"

export const MainContainer = styled(Grid)(
  ({}) => `
    padding:8px;
    border-radius:6px;
    `
)

export const Title = styled(Typography)(
  ({ theme: { palette } }) => `
    color:${palette.primary.main}};
  `
)
